import React, { useState } from "react";
import {
  makeStyles,
  Box,
  Button,
  TextField,
  Chip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@material-ui/core";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  getTalentPools,
  saveTalentPool,
  deleteTalentPool,
} from "../../../utils/matchScore";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#ffffff",
    padding: theme.spacing(1.5),
    margin: `${theme.spacing(1)}px 0`,
    borderRadius: 4,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontWeight: 600,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.5),
  },
  empty: {
    color: theme.palette.grey[600],
    fontSize: "0.85rem",
  },
}));

const TalentPools = ({ currentQuery, onLoadPool }) => {
  const classes = useStyles();
  const [pools, setPools] = useState(getTalentPools());
  const [dialogOpen, setDialogOpen] = useState(false);
  const [name, setName] = useState("");

  const handleSave = () => {
    if (!name.trim()) return;
    const next = saveTalentPool(name, currentQuery);
    setPools(next);
    setName("");
    setDialogOpen(false);
  };

  const handleDelete = (poolName) => {
    setPools(deleteTalentPool(poolName));
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="subtitle2" className={classes.title}>
          <BookmarkIcon fontSize="small" /> Talent Pools
        </Typography>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => setDialogOpen(true)}
          disabled={!currentQuery}
        >
          Save current search
        </Button>
      </Box>

      {pools.length === 0 ? (
        <Typography className={classes.empty}>
          No saved pools yet. Apply filters and save them to revisit a candidate
          segment instantly.
        </Typography>
      ) : (
        <Box className={classes.chips}>
          {pools.map((p) => (
            <Tooltip
              key={p.name}
              title={`Saved ${new Date(p.savedAt).toLocaleDateString()}`}
            >
              <Chip
                label={p.name}
                onClick={() => onLoadPool && onLoadPool(p.query)}
                onDelete={() => handleDelete(p.name)}
                deleteIcon={<DeleteIcon />}
                color="primary"
                variant="outlined"
              />
            </Tooltip>
          ))}
        </Box>
      )}

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Save talent pool</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Save the current filter combination as a named pool you can revisit.
          </Typography>
          <TextField
            autoFocus
            fullWidth
            label="Pool name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Senior React Engineers — EU"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TalentPools;
